export default class ClubExamType {

    constructor() {
        this.id = null;
        this.title = null;
        this.colour = '#ffffff';
        this.archived = true;
        this.isDeletable = true;
    }

    static fromData(data) {
        if (!data) {
            return;
        }

        let clubExamType = new ClubExamType();
        clubExamType.id = data.id;
        clubExamType.title = data.title;
        clubExamType.colour = data.colour;
        clubExamType.archived = data.archived;
        clubExamType.isDeletable = data.isDeletable;

        return clubExamType;
    }
}
